import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { IUserMe } from '../../commons/interfaces/user';
import { useUserMe } from '../../commons/hooks/userme';
import IconCheck from '../../images/check-green.svg';
import './thanks.scss';

const Thanks = () => {
    const history = useHistory();
    const [userMe, setUserMe] = useUserMe();

    const goOut = () => {
        setUserMe.reset();
        history.push('/signin');
    };

    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    useEffect(() => {
        const { postulacionenviada } = userMe as IUserMe;

        if (!postulacionenviada) {
            history.push('/');
        }
    }, [userMe]);

    return (
        <div className="ThanksWrapFull">
            <div
                className="ThanksBanner"
                style={{ backgroundImage: 'url(/images/thanks-left.png)' }}
            ></div>
            <div className="ThanksWrap">
                <div className="ThanksWrapInner">
                    <div className="ThanksLogo">
                        <img
                            alt="Empresas que transforman el Perú"
                            src="/images/logo-big.png"
                            onClick={handleBackLanding}
                        />
                    </div>
                    <div className="ThanksWrapContext">
                        <div className="mb1">
                            <img src={IconCheck} alt="" />
                            <p className="ThanksWrapContextTitle">
                                ¡Ya te encuentras postulando!
                            </p>
                            <p className="ThanksWrapContextSub">
                                Si necesitas comunicarte con nosotros,<br></br>{' '}
                                escríbenos a{' '}
                                <a href="mailto:empresasquetransforman@ipae.pe">
                                    empresasquetransforman@ipae.pe
                                </a>
                                .
                            </p>
                            <p className="ThanksWrapContextGoodLuck">
                                ¡Gracias!
                            </p>
                        </div>
                        <div className="mb1">
                            <Link
                                className="big fweight"
                                to="/signin"
                                onClick={goOut}
                            >
                                Salir
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Thanks;
